import React from 'react'

interface LoadingSkeletonProps {
  className?: string
  count?: number
  height?: string | number
}

export const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({
  className = '',
  count = 1,
  height = '1rem'
}) => {
  return (
    <div className={`animate-pulse ${className}`}>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bg-slate-200 rounded mb-2 last:mb-0"
          style={{ height }}
        />
      ))}
    </div>
  )
}
